export default __webpack_public_path__ + "static/sustainability_2-a9e4e6362e6c4056473dc66bba709f74.webp";